module.exports = __webpack_public_path__ + "static/media/weedmaps_logo.a8c9ca2c.png";